import WForeverBox from './WForeverBox'

export default WForeverBox
